import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { notification } from 'antd'
import { getApi } from '@BUP/services/Axios'
import { useTranslation } from 'react-i18next'
import { useAuthUser } from '@BUP/services/auth/use-auth-user.jsx'
import { useSignIn } from '@BUP/services/auth/use-sign-in'
import { useQueryClient } from '@tanstack/react-query'
import { capitalizeFirst } from '@BUP/utils'

export function useChangePassword () {
  const [error, setError] = useState(null)
  const [errorMessage, setErrorMessage] = useState('')
  const navigate = useNavigate()
  const { mutate: signIn } = useSignIn()
  const authUser = useAuthUser()
  const i18n = useTranslation()
  const queryClient = useQueryClient()
  const { email } = authUser
  const changePassword = async (password, passwordConfirmation) => {
    const client = await getApi('schools', { version: 3 })
    return client
      .patch('current-user', { password, passwordConfirmation })
      .then(() => signIn(email, password))
      .then(async () => {
        // Force refetch of current user data to ensure fresh data without 'bup-password-change-pending' header
        await queryClient.refetchQueries({ queryKey: ['current', 'current-user', 3] })

        notification.info({
          style: { fontWeight: 500, fontSize: 17 },
          message: capitalizeFirst(i18n.t('common.resources.user.actions.update.password.success')),
          // description: t('pages.profile.resetPasswordEmailHasBeenSent', { email }),
          duration: 5
        })

        // Navigate to home after refetch completes
        navigate('/')
      })
      .catch(error => {
        setError(error)
        const errorMessage = capitalizeFirst(i18n.t('common.resources.user.actions.update.password.failure'))
        setErrorMessage(errorMessage)
      })
  }
  return {
    errorMessage,
    error,
    changePassword
  }
}
